import http from 'plugins/axios'

export default {
  list(data) {
    return http.get({
      url: '/ta/admin/tenant/welfare/user/coupon/list',
      data,
    })
  },
  retryGrant(data) {
    return http.post({
      url: '/ta/admin/tenant/welfare/user/coupon/retryGrant',
      data,
    })
  },
}
